import {IPromptInternalProps, IPromptProps} from "../types/IPromptProps";

export const defaultParams: IPromptProps & IPromptInternalProps = {
    isPromptOpen: false,
    text: "",
    input: undefined,
    cancelButtonText: "Anuluj",
    okButtonText: "Ok"
};

export const defaultParamsWithInput: IPromptProps & IPromptInternalProps = {
    isPromptOpen: false,
    text: "",
    input: {
        type: "text"
    },
    cancelButtonText: "Anuluj",
    okButtonText: "Zapisz"
};
import {IPromptInternalProps, IPromptProps} from "../types/IPromptProps";

export const defaultParams: IPromptProps & IPromptInternalProps = {
    isPromptOpen: false,
    text: "",
    input: undefined,
    cancelButtonText: "Anuluj",
    okButtonText: "Ok"
};

export const defaultParamsWithInput: IPromptProps & IPromptInternalProps = {
    isPromptOpen: false,
    text: "",
    input: {
        type: "text"
    },
    cancelButtonText: "Anuluj",
    okButtonText: "Zapisz"
};
